import React, { Component } from 'react'
import arrow from '../../../assets/icons/arrow.png'
import './styles.sass'

interface SelectOptions { 
  name: string,
  label?: string,
  placeholder?: string,
  options: any[],
  readonly?: boolean,
  disabled?: boolean,
  value?: any,
  searchValue?: string,
  icon?: any,
  hasSearch?: boolean,
  loading?: boolean,
  allowEmpty?: boolean,
  required?: boolean,
  onChange?: (value: any) => any,
  onSearchChange?: (value: any) => any
}

export class Select extends Component<SelectOptions> {
  ref: React.RefObject<HTMLInputElement>
  handleDocumentClick: ((e: MouseEvent) => void) | null = null

  constructor(props: any) {
    super(props);
    this.ref = React.createRef();
  }

  state = {
    search: '',
    currentValue: this.props.value || '',
    opened: null
  }

  componentDidMount() {
    this.handleDocumentClick = (e: MouseEvent) => {
      if(this.props.disabled || this.props.readonly) return;

      const currentRef = this.ref.current as HTMLElement;
      const searchInput = currentRef?.querySelector('.search-input');

      if (searchInput?.contains(e.target as HTMLElement)) {
        return
      };

      const clickedInComponent = this.ref.current && (this.ref.current as HTMLElement).contains(e.target as HTMLElement);

      if(clickedInComponent) {
        if ((e.target as HTMLElement).className === 'option disabled noselect') {
          return;
        };

        this.setState({ opened: !this.state.opened }, () => {
          currentRef.style.zIndex = this.state.opened ? '10000' : '1' ;
        });
      } else {
        this.setState({ opened: false });
        if(currentRef) {
          currentRef.style.zIndex = '1';
        };
      };
    };

    document.addEventListener('click', this.handleDocumentClick);
  }

  componentWillUnmount() {
    if (this.handleDocumentClick) {
      document.removeEventListener('click', this.handleDocumentClick);
    }
  }

  componentDidUpdate(prevProps: Readonly<SelectOptions>) {
    if(prevProps.value !== this.props.value) {
      this.setState({ currentValue: this.props.value || '' });
    };
  }

  onSelect = (option: any) => {
    this.props.onChange && this.props.onChange(option.value);
    this.setState({ currentValue: option.value });
  }

  onSearch = (e: any) => {
    this.setState({ search: e.target.value });

    if (this.props.onSearchChange) {
      this.props.onSearchChange && this.props.onSearchChange(e.target.value);
    };
  }

  render() {
    return (
      <div ref={this.ref} className={'select-container '+(this.props.disabled ? 'disabled' : '')+(this.props.readonly ? 'readonly' : '')+(this.state.opened ? 'opened' : '')}>
        {this.props.label && <label>{this.props.label}{this.props.required && <span className="required-asterisk">*</span>}</label>}
        <div className={'select-input-container '+(this.props.icon ? 'with-icon' : '')}>
          {this.props.icon && <img src={this.props.icon} className='icon' alt='select-icon' />}
          <input
          value={this.state.currentValue ? (this.props.options?.find(x => x.value === this.state.currentValue)?.label || '') : ''}
          placeholder={this.props.placeholder}
          disabled={this.props.disabled}
          readOnly/>
          <img className='arrow' src={arrow} alt='arrow-icon' />
        </div>
        {this.state.opened && 
        <div className='options'>
          {
            this.props.hasSearch &&
            <input
            className='search-input'
            value={this.props.searchValue} 
            onChange={(e) => this.onSearch(e)}
            placeholder='Pesquisar, (escreva pelo menos 3 caractéres)' />
          }
          <ul>
            { this.props.loading && <li>Pesquisando...</li>}
            { !this.props.loading && this.props.options && this.props.options.length > 0 && 
              <>
                {this.props.allowEmpty !== false && (
                  <li key={this.props.label+'_empty'} onClick={() => this.onSelect({ value: null })}>-</li>
                )}
                {
                  !this.props.loading &&
                  this.props.options?.map((x: any, i: number) => 
                  <li key={`${x.label}_${x.value}_${i}`} className={x.disabled ? 'option disabled noselect' : 'option'} onClick={() => !x.disabled && this.onSelect(x)}>{x.label}</li>)
                }
              </>
            }
            { !this.props.loading && this.props.options && this.props.options.length === 0 && <li>Nenhum resultado</li>}
          </ul>
        </div>}
      </div>
    )
  }
}